<div>
  <app-user-create-edit (parentComp)="reloadTable($event)"></app-user-create-edit>
</div>

<!-- HEADER -->
<app-screen-heading [title]="'User management'" [hideButtonsOnSmallScreen]="false" [hideBottomBorder]="false">
  <ng-container smallScreenButtons>
    <button (click)="selectUser()">
      <span class="text">Add User</span>
    </button>
    <!-- <button mat-menu-item >
      <span class="text">Upload New</span>
      </button> -->
  </ng-container>
  <ng-container regularButtons>
    <button class="btn" (click)="selectUser()">
      <span class="text">Add User</span>
      <img src="assets/images/icons/add-w.svg" alt="Add icon">
    </button>
    <!-- <button class="btn btn-outline">
      <span class="text">Upload New</span>
      <img src="assets/images/icons/upload.svg" alt="Upload icon">
      </button> -->
  </ng-container>
</app-screen-heading>

<!-- FILTERS -->
<app-table-filter [showSearch]="true" [searchPlaceholder]="'Search by Name'"
  (filterChange)="handleChangeFilter($event)">
</app-table-filter>

<div class="page-table">
  <table>
    <thead>
      <tr class="header-columns">
        <td><span>Name</span></td>
        <td><span>Email</span></td>
        <td><span>Source</span></td>
        <td><span>Role</span></td>
        <td><span>Created By</span></td>        
        <td><span>Action</span></td>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of users" class="bodyRow clickable actions-click">
        <td><span>{{item.firstName | hasValue}} {{item.lastName | hasValue}}</span></td>
        <td><span>{{item.email | hasValue}}</span></td>
        <td>
          <span *ngFor="let application of item.applications">{{application.displayName}}<br></span>
        </td>
        <td><span>{{item.role | hasValue}}</span></td>
        <td><span>{{item.createdBy | hasValue}}</span></td>
        <td class="d-flex" style="gap: 5px;">            
          <div class="action-btn-group">
            <button class="enable-btn" (click)="openTabChangeStatus(item, false)">Enable</button>
            <button class="disable-btn" (click)="openTabChangeStatus(item, true)">Disable</button>
          </div>
          
          <span class="button-action" title="Edit"><img src="assets/images/icons/edit.jpg" (click)="selectUser(item.id)" /> </span>
          <span class="button-action" title="Reset password"><img src="assets/images/icons/reset-password.jpg" (click)="resetPassword(item.email)" /> </span>
          <span class="button-action" title="Remove"><img src="assets/images/icons/bin.png" data-toggle="modal" data-target="#deleteModal"
              (click)="openTabDelete(item.id)" /></span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="pagination-wrapper">
  <app-pagination [pageSize]="pageSize" [currentPage]="currentPage" [count]="count" (pageChange)="pageChange($event)">
  </app-pagination>
  <app-modal-confirm *ngIf="showDeleteModal" (confirm)="delete()" (cancel)="cancelDelete()">
  </app-modal-confirm>
  <app-modal-confirm *ngIf="showChangeStatusModal" (confirm)="changeUserStatus()" (cancel)="cancelChangeStatus()">
  </app-modal-confirm>